import { createContext } from "react";

const UploadContext = createContext();

export default UploadContext;